import React from "react";
import "./GPTeam.css";

const teamMembers = [
  { name: " सौ. करिश्मा किरण पाटील ", designation: "ग्रामपंचायत उसाटणे ",  imageUrl: "/images/dilip.jpeg" },
  { name: "सौ. आरती हरिदाश पाटील", designation: "ग्रामपंचायत उसाटणे",  imageUrl: "/images/ashok.jpeg" },
  { name: "श्रीम. रंगुबाई विष्णू पाटील  ", designation: "ग्रामपंचायत उसाटणे",  imageUrl: "/images/vijayata.jpeg" },
  { name: "श्री सदाशिव बाळकृष्ण पाटील", designation: "ग्रामपंचायत उसाटणे", imageUrl: "/images/pramila.jpeg" },
  { name: "सौ. पूजा प्रकाश पाटील", designation: "ग्रामपंचायत उसाटणे",  imageUrl: "/images/kavita.jpeg" },
  
  ];

const karmachariMembers = [
 /* { name: "--", designation: " ग्रामपंचायत कर्मचारी ",  imageUrl: "/images/-.jpeg" },
  { name: "--", designation: "रोजगार सेवक उसाटणे",   imageUrl: "/images/-.jpeg" },
  { name: "-- ", designation: "संगणक प्ररिचालक उसाटणे",   imageUrl: "/images/-.jpeg" },
  { name: " श्री. ", designation: "सफाई  कर्मचारी", imageUrl: "/images/sharad.jpeg" },
  { name: "श्री.  ", designation: "लिपिक  कर्मचारी", imageUrl: "/images/puru.jpeg" },
  { name: "श्री.", designation: "ग्रामपंचायत कर्मचारी", imageUrl: "/images/nikhil.jpeg" },
  { name: "श्री.", designation: "संगणक परिचालक", imageUrl: "/images/pritam.jpeg" },
  { name: "श्री.", designation: "पानी पुरवठा  कर्मचारी", imageUrl: "/images/ajay.jpeg" },*/
];


const GPTeam = () => {
  return (
    <div className="gp-container">

      {/* HEADER */}
      <div className="gp-header">
        <img
          src="/images/sj1.jpg"
          alt="Emblem"
          className="gp-logo"
        />
        <h1 className="gp-title">ग्रामपंचायत कार्यकारी समिती</h1>
        <p className="gp-subtitle">
          The Governing Body — Committed to Community Service
        </p>
      </div>

      {/* TEAM CARDS */}
      <div className="gp-grid">
        {teamMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
            <p className="gp-phone"> {member.phone}</p>
          </div>
        ))}
      </div>
      {/* KARMACHARI SECTION */}
      <h2 className="gp-section-title">--</h2>

      <div className="gp-grid">
        {karmachariMembers.map((member, index) => (
          <div key={index} className="gp-card">
            <img
              src={member.imageUrl}
              alt={member.name}
              className="gp-photo"
            />
            <h2 className="gp-name">{member.name}</h2>
            <p className="gp-designation">{member.designation}</p>
          </div>
        ))}
      </div>

      {/* FOOTER */}
      <div className="gp-footer">
        © 2026 Gram Panchayat — All Rights Reserved.
        
      </div>
    </div>
  );
};

export default GPTeam;
